// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — confirm-comment.styled.classic.js, новая — confirm-comment.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './confirm-comment.styled.classic';
import * as cp from './confirm-comment.styled.cp';

export const Block = isCp ? cp.Block : classic.Block;
export const Content = isCp ? cp.Content : classic.Content;
export const Fields = isCp ? cp.Fields : classic.Fields;
